import { RouteInfo } from './sidebar.metadata';

export const ROUTES: RouteInfo[] = [
  // {
  //   path: '/dashboard-demo',
  //   module : 'dashboard-demo',
  //   title: 'Dashboard',
  //   icon: 'mdi mdi-view-dashboard',
  //   class: '',
  //   extralink: false,
  //   submenu: []
  // },
  {
    path: '',
    module: '',
    title: 'Management',
    icon: 'icon-Management',
    class: 'has-arrow',
    extralink: false,
    submenu: [

      // {
      //   path: '/oil-major-master',
      //   module : 'oil_major',
      //   title: 'Oil major',
      //   icon: 'mdi mdi-book-open-page-variant',
      //   class: '',
      //   extralink: false,
      //   submenu: []
      // },
      // {
      //   path: '/port',
      //   module : 'ports',
      //   title: 'Ports',
      //   icon: 'mdi mdi-book-open-page-variant',
      //   class: '',
      //   extralink: false,
      //   submenu: []
      // },
      // {         

      //   path: '/vessel-flag',
      //   module : 'vessel_flag',
      //   title: 'Vessel Flag',
      //   icon: 'mdi mdi-book-open-page-variant',
      //   class: '',
      //   extralink: false,
      //   submenu: []
      // },{
      //   path: '/vessel-type',
      //   module : 'vessel_type',
      //   title: 'Vessel Type',
      //   icon: 'mdi mdi-book-open-page-variant',
      //   class: '',
      //   extralink: false,
      //   submenu: []
      // },{
      //   path: '/vessel-class',
      //   module : 'vessel_class',
      //   title: 'Vessel Class',
      //   icon: 'mdi mdi-book-open-page-variant',
      //   class: '',
      //   extralink: false,
      //   submenu: []
      // },
      {
        path: '/vessel-owner',
        module: 'vessel_owner',
        title: 'Owner List',
        icon: 'mdi mdi-book-open-page-variant',
        class: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/vessel-master',
        module: 'vessel_master',
        title: 'Vessel Particulars',
        icon: 'mdi mdi-book-open-page-variant',
        class: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/group',
        module: 'vessel_group',
        title: 'Vessel Group',
        icon: 'mdi mdi-book-open-page-variant',
        class: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/fleet',
        module: 'vessel_fleet',
        title: 'Vessel Fleet',
        icon: 'mdi mdi-book-open-page-variant',
        class: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/inspector',
        module: 'inspector',
        title: 'Inspector',
        icon: 'mdi mdi-book-open-page-variant',
        class: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/course',
        module: 'course',
        title: 'Course',
        icon: 'mdi mdi-book-open-page-variant',
        class: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/training-type',
        module: 'training_type',
        title: 'Training Type',
        icon: 'mdi mdi-book-open-page-variant',
        class: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/rank',
        module: 'rank',
        title: 'Rank',
        icon: 'mdi mdi-book-open-page-variant',
        class: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/trainer-master',
        module: 'trainer',
        title: 'Trainer',
        icon: 'mdi mdi-book-open-page-variant',
        class: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/office-location',
        module: 'office_location',
        title: 'Office Location',
        icon: 'mdi mdi-book-open-page-variant',
        class: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/software',
        module: 'software',
        title: 'Software',
        icon: 'mdi mdi-book-open-page-variant',
        class: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/action_campaign',
        module : 'action_campaign',
        title: 'Action Campaign',
        icon: '',
        class: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/kpi-category',
        module : 'kpi_category',
        title: 'KPI Category',
        icon: '',
        class: '',
        extralink: false,
        submenu: [] 
      },
      {
        path: '/kpi-detail',
        module : 'kpi_detail',
        title: 'KPI Detail',
        icon: '',
        class: '',
        extralink: false,
        submenu: [] 
      },
      {
        path: '/inspection-type',
        module : 'inspection-type',
        title: 'Inspection Type',
        icon: '',
        class: '',
        extralink: false,
        submenu: [] 
      },
      {
        path: '/deficiency-cause',
        module : 'deficiency-cause',
        title: 'Deficiency Cause',
        icon: '',
        class: '',
        extralink: false,
        submenu: [] 
      },
      
    ]
  },

  {
    path: '/inspectionRequest',
    module: 'inspection_request',
    title: 'Inspection Request',
    icon: 'mdi mdi-file-check',
    class: '',
    extralink: false,
    submenu: []
  },
  // {
  //   path: '/configuration',
  //   module : 'configuration',
  //   title: 'Configuration',
  //   icon: 'mdi mdi-crown',
  //   class: '',
  //   extralink: false,
  //   submenu: []
  // },
  {
    path: '',
    module: '',
    title: 'Configuration',
    icon: 'mdi mdi-settings',
    class: 'has-arrow',
    extralink: false,
    submenu: [
      {
        path: '/configuration',
        module: 'settings',
        title: 'Settings',
        icon: 'mdi mdi-book-open-page-variant',
        class: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/auto-reports',
        module: 'auto_reports',
        title: 'Auto Reports',
        icon: 'mdi mdi-book-open-page-variant',
        class: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/users',
        module: 'users',
        title: 'User Management',
        icon: 'mdi mdi-book-open-page-variant',
        class: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/permission',
        module: 'permission',
        title: 'Permission',
        icon: 'mdi mdi-book-open-page-variant',
        class: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/sire',
        module: 'sire',
        title: 'SIRE VIQ',
        icon: 'mdi mdi-book-open-page-variant',
        class: '',
        extralink: false,
        submenu: []
      },
    ]
  },
  {
    path: '',
    module: '',
    title: 'Upload Report',
    icon: 'mdi mdi-briefcase-upload',
    class: 'has-arrow',
    extralink: false,
    submenu: [
      {
        path: '/sire_report',
        module: 'sire_report',
        title: 'Sire Report',
        icon: 'mdi mdi-book-open-page-variant',
        class: '',
        extralink: false,
        submenu: []
      },
      // {
      //   path: '/sire',
      //   module : 'sire',
      //   title: 'Sire',
      //   icon: 'mdi mdi-book-open-page-variant',
      //   class: '',
      //   extralink: false,
      //   submenu: []
      // },
      // {
      //   path: '/cdi',
      //   module : 'cdi_report',
      //   title: 'CDI Report',
      //   icon: 'mdi mdi-book-open-page-variant',
      //   class: '',
      //   extralink: false,
      //   submenu: []
      // },
      // {
      //   path: '/others-xml-file',
      //   module : 'others_xml_file',
      //   title: 'Other Report',
      //   icon: 'mdi mdi-book-open-page-variant',
      //   class: '',
      //   extralink: false,
      //   submenu: []
      // },
    ]
  },
  {
    path: '/inspectionPlanning',
    module: 'inspectionPlanning',
    title: 'Monitoring and Planning',
    icon: 'icon-Monitor-2',
    class: '',
    extralink: false,
    submenu: []
  },
  // {
  //   path: '/wizard',
  //   module : 'wizard',
  //   title: 'Analytics',
  //   icon: 'mdi mdi-chart-line',
  //   class: '',
  //   extralink: false,
  //   submenu: []
  // },


  // {
  //   path: '',
  //   module : '',
  //   title: 'Analytics',
  //   icon: 'mdi mdi-chart-line',
  //   class: 'has-arrow',
  //   extralink: false,
  //   submenu: [
  //     {
  //       path: '/dashboard-demo',
  //       module : 'dashboard-demo',
  //       title: 'Analytics Dashboard',
  //       icon: 'mdi mdi-book-open-page-variant',
  //       class: '',
  //       extralink: false,
  //       submenu: []
  //     },
  //     {
  //       path: '/wizard',
  //       module : 'wizard',
  //       title: 'Reports Wizard',
  //       icon: 'mdi mdi-book-open-page-variant',
  //       class: '',
  //       extralink: false,
  //       submenu: []
  //     },
  //   ]
  // },


  {
    path: '/wizard',
    module: 'wizard',
    title: 'Reports Wizard',
    icon: 'mdi mdi-chart-line',
    class: '',
    extralink: false,
    submenu: []
  },




  {
    //path: '/tmsa',
    //module : 'tmsa',
    //title: 'TMSA',
    //icon: 'mdi mdi-format-wrap-square',
    //class: '',
    //extralink: false,
    //submenu: []

    path: '/tmsa',
    module: '',
    title: 'TMSA',
    icon: 'mdi mdi-format-wrap-square',
    class: 'has-arrow',
    extralink: false,
    submenu: [
      {
        path: '',
        module: '',
        title: 'Obs. Catcher',
        icon: 'mdi mdi-book-open-page-variant',
        class: 'has-arrow',
        extralink: false,
        submenu: [
          {
            path: '/defect_damage',
            module: 'defect_damage',
            title: 'Defect Damage',
            icon: 'mdi mdi-book-open-page-variant',
            class: '',
            extralink: false,
            submenu: []
          },
          {
            path: '/non_sire',
            module: 'non_sire',
            title: 'Non SIRE',
            icon: 'mdi mdi-book-open-page-variant',
            class: '',
            extralink: false,
            submenu: []
          },
          {
            path: '/psc',
            module: 'psc',
            title: 'PSC',
            icon: 'mdi mdi-book-open-page-variant',
            class: '',
            extralink: false,
            submenu: []
          },
          {
            path: '/terminal_inspection',
            module: 'terminal_inspection',
            title: 'Terminal Inspection',
            icon: 'mdi mdi-book-open-page-variant',
            class: '',
            extralink: false,
            submenu: []
          },
          {
            path: '/flag_state_inspection',
            module: 'flag_state_inspection',
            title: 'Flag State Inspection',
            icon: 'mdi mdi-book-open-page-variant',
            class: '',
            extralink: false,
            submenu: []
          },
          {
            path: '/external_audit',
            module: 'external_audit',
            title: 'External Audit',
            icon: 'mdi mdi-book-open-page-variant',
            class: '',
            extralink: false,
            submenu: []
          },
          {
            path: '/internal_audit',
            module: 'internal_audit',
            title: 'Internal Audit',
            icon: 'mdi mdi-book-open-page-variant',
            class: '',
            extralink: false,
            submenu: []
          },
          {
            path: '/thirdParty_inspection',
            module: 'thirdParty_inspection',
            title: 'Third Party Inspection',
            icon: 'mdi mdi-book-open-page-variant',
            class: '',
            extralink: false,
            submenu: []
          },
          {
            path: '/sailing_navigation_audit',
            module: 'sailing_navigation_audit',
            title: 'Sailing Navigation Audit',
            icon: 'mdi mdi-book-open-page-variant',
            class: '',
            extralink: false,
            submenu: []
          },
          {
            path: '/in_port_navigation_verification',
            module: 'in_port_navigation_verification',
            title: 'In Port Navigation Verification',
            icon: 'mdi mdi-book-open-page-variant',
            class: '',
            extralink: false,
            submenu: []
          },
          {
            path: '/cargo_audit',
            module: 'cargo_audit',
            title: 'Cargo Audit',
            icon: 'mdi mdi-book-open-page-variant',
            class: '',
            extralink: false,
            submenu: []
          },
          {
            path: '/engineering_audit',
            module: 'engineering_audit',
            title: 'Engineering Audit',
            icon: 'mdi mdi-book-open-page-variant',
            class: '',
            extralink: false,
            submenu: []
          },
          {
            path: '/mlc_audit',
            module: 'mlc_audit',
            title: 'MLC Audit',
            icon: 'mdi mdi-book-open-page-variant',
            class: '',
            extralink: false,
            submenu: []
          },
          {
            path: '/mooring_audit',
            module: 'mooring_audit',
            title: 'Mooring Audit',
            icon: 'mdi mdi-book-open-page-variant',
            class: '',
            extralink: false,
            submenu: []
          },
          {
            path: '/supritendent_inspection',
            module: 'supritendent_inspection',
            title: 'Supritendent Inspection',
            icon: 'mdi mdi-book-open-page-variant',
            class: '',
            extralink: false,
            submenu: []
          },
          {
            path: '/other_misc_audit_and_inspection',
            module: 'other_misc_audit_and_inspection',
            title: 'Other MISC Audit and Inspection',
            icon: 'mdi mdi-book-open-page-variant',
            class: '',
            extralink: false,
            submenu: []
          }

        ]
      },
      {
        path: '/training',
        module: 'shore_staff_training',
        title: 'Shore Staff Training',
        icon: 'mdi mdi-book-open-page-variant',
        class: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/ship-training',
        module: 'ship_staff_training',
        title: 'Ship Staff Training',
        icon: 'mdi mdi-book-open-page-variant',
        class: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/sea-farer',
        module: 'sea_farer',
        title: 'Shore Assignment',
        icon: 'mdi mdi-book-open-page-variant',
        class: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/softwareManagement',
        module: 'softwareManagement',
        title: 'Software Management',
        icon: 'mdi mdi-book-open-page-variant',
        class: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/office-audit',
        module: 'office_audit',
        title: 'Office Audit',
        icon: 'mdi mdi-book-open-page-variant',
        class: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/retention_rate_calculator',
        module: 'retention_rate_calculator',
        title: 'Retention Rate Calculator',
        icon: 'mdi mdi-book-open-page-variant',
        class: '',
        extralink: false,
        submenu: []
      },
      {
        path: '/kpi-report',
        module: 'kpi_report',
        title: 'KPI Report',
        icon: 'mdi mdi-book-open-page-variant',
        class: '',
        extralink: false,
        submenu: []
      },
    ]
  },
  {
    path: '/subscription',
    module: 'my_subscription',
    title: 'My Subscription',
    icon: 'mdi mdi-email-variant',
    class: '',
    extralink: false,
    submenu: []
  },
  {
    path: '/inspector-search',
    module: 'inspector_search',
    title: 'Inspector Search Report',
    icon: 'mdi mdi-email-variant',
    class: '',
    extralink: false,
    submenu: []
  }

];